// extracted by mini-css-extract-plugin
module.exports = {"section-image-row":"image-row_section-image-row__bPfVy","image-row-banner-wrap":"image-row_image-row-banner-wrap__O9Ar6"};